// this module contains share logic between comm/home detail mobile pages
define('mobileFormsCommon',[], function () {
  /**
  * Toggles the required attribute from the phone input when the preferred contact method is Phone or Text Message.
  * @param {object} event The event object after changing the preferred contact method dropdown.
  */
  function updateRequiredPhoneInput(event) {
    const selectedOption = event.target.options ? event.target.options[event.target.selectedIndex] : event.target;
    const selectedValue = selectedOption.value;
    const form = event.target.closest("form");
    const phoneInput = form.querySelector("[name='phone']");
    const phoneInputLabel = form.querySelector("[data-phone-input-label]");
    const previouslySelectedItems = form.querySelectorAll("[data-contact-method] [selected]");

    for (var i = 0; i < previouslySelectedItems.length; i++) {
        previouslySelectedItems[i].removeAttribute("selected");
        previouslySelectedItems[i].removeAttribute("data-segment-identity-data");
    }

    selectedOption.setAttribute("selected", "");
    selectedOption.setAttribute("data-segment-event-preferred_contact_method", selectedValue);

    if ((selectedValue === "Phone" || selectedValue === "Text Message") &&
      !phoneInput.hasAttribute("required")) {
      if (phoneInputLabel) {
        phoneInputLabel.textContent = phoneInputLabel.textContent + "*";
      }

      phoneInput.setAttribute("required", "");
      phoneInput.focus();
    }
    else if ((selectedValue !== "Phone" && selectedValue !== "Text Message") &&
      phoneInput.hasAttribute("required")) {
      if (phoneInputLabel) {
        phoneInputLabel.textContent = phoneInputLabel.textContent.replace("*", "");
      }

      phoneInput.removeAttribute("required");
    }
  }

  /**
   * @private 
   * Sets the change event for preferred method of contact <select> elements
   */
  const onChangeContactMethod = function(form) {
    const contactMethodInput = form.querySelector("[data-contact-method]");

    if (contactMethodInput) {
      contactMethodInput.addEventListener("change", function (event) {
        updateRequiredPhoneInput(event);
      });
    }
  }

  /**
   * Gets the preferred method of contact selected in the form <select>, if any
   * @param {any} form Form element
   * @returns {string} The value of the selected dropdown, empty if the <select> doesn't exists.
   */
  const getPreferredContactMethod = function (form) {
    const contactMethodInput = form.querySelector("[data-contact-method]");
    const selectedOption = contactMethodInput
      ? contactMethodInput.options[contactMethodInput.selectedIndex].value
      : "";

    return selectedOption;
  }

  /**
  * Gets the additional information that should be included in the comment field and checkboxes of the forms.
  * @param {element} formElem The floating form element.
  * @returns The information of the checkboxes and comments area formatted
  */
    var getOnPageFormCommentData = function (formElem) {
        var formOptions = formElem.querySelectorAll("[name='form-options']:checked");
        var formText = "";

        for (var i = 0; i < formOptions.length; ++i) {
            var currentOption = formOptions[i];
            formText += formText === ""
                ? currentOption.getAttribute("data-comment") + ","
                : " " + currentOption.getAttribute("data-comment") + ",";
        }
        var commentArea = formElem.querySelector("textarea") || formElem.querySelector("[name='Comments']");
        var interestIn = "Interested in: " + formText.slice(0, -1) + ".";

        if (commentArea && commentArea.value != "" && formText != "") {
            formText = commentArea.value + " - " + interestIn;
        }

        else if (formText != "" && commentArea && commentArea.value == "") {
            formText = interestIn;
        }

        else if (formText == "" && commentArea && commentArea.value != "") {
            formText = commentArea.value;
        }
        return formText;
    }

  /**
   * This methods sets the Match maker flag if the user request a brochure with the include similar comms check selected
   */
  var setMatchMakerAsSelected = function () {
    var input = document.getElementById("MatchMakerFlagOptedIn");
    if (input) {
      input.value = "True";
    }
  }

  /**
   * This method will execute actions if the user has requested recommended communities on a brochure.
   * @param {boolean} sendAlerts flag which has the value of if the user has selected or not to request recommended communities
   */
  var executeActionsAfterRequestRecommended = function(sendAlerts) {
    if (sendAlerts === true) {
      setMatchMakerAsSelected();
    }
  }

/**
* Returns the selected topics from a form.
* @param {object} form to extract the topics
*/
  var getSelectedTopics = function(form) {
    let topics = 'Free Digital Brochure';
    const topicList = form && form.querySelectorAll('[name=form-options]');
    if (topicList && topicList.length > 0) {
      for (i = 0; i < topicList.length; i++) {
        if (topicList[i].checked) {
          topics += ', ' + topicList[i].dataset.comment;
        }
      }
    }
    return topics;
  }

  return {
    getPreferredContactMethod: getPreferredContactMethod,
    onChangeContactMethod: onChangeContactMethod,
    getOnPageFormCommentData: getOnPageFormCommentData,
    setMatchMakerAsSelected: setMatchMakerAsSelected,
    executeActionsAfterRequestRecommended: executeActionsAfterRequestRecommended,
    getSelectedTopics: getSelectedTopics,
}
});

